import { View } from "binder"
import { IbanSelectorSelectorViewModel } from "src/erp/arap/rawData/ibanSelector-viewModel";
import { IbanGatewayViewModel } from "./ibanGateway-viewModel"

export class IbanGatewayView extends View<IbanGatewayViewModel>{
    GetViewUniqueId(): string {
        return "V-30839CC1-E578-40E7-B1B0-0F27A7D0A38B"
    }
    loadHtml(): string {
        let element = require('./ibanGateway.html').default;
        let style = require('./ibanGateway.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set accountSelector(v: IbanSelectorSelectorViewModel) { this._accountSelector = v; } public get accountSelector(): IbanSelectorSelectorViewModel { return this._accountSelector;} private _accountSelector: IbanSelectorSelectorViewModel;
    public set destinationIBanNumber(v: string) { this._destinationIBanNumber = v; } public get destinationIBanNumber(): string { return this._destinationIBanNumber;} private _destinationIBanNumber: string;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
}
